import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

export default function ForgotPassword() {
  const [email,    setEmail]    = useState('');
  const [sent,     setSent]     = useState(false);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  async function submit(e) {
    e.preventDefault();
    if (!email) { setError('Please enter your email address.'); return; }
    setError(''); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <Link to="/login" style={s.back}>← Back to login</Link>
        <div style={s.logo}>Qu<span style={{ color: '#4f6ef7' }}>vera</span></div>

        {!sent ? (
          <>
            <div style={s.iconWrap}>
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <rect x="2" y="7" width="24" height="17" rx="3" stroke="#4f6ef7" strokeWidth="1.8"/>
                <path d="M2 10l12 8 12-8" stroke="#4f6ef7" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            </div>
            <h2 style={s.h2}>Forgot your password?</h2>
            <p style={s.p}>Enter your email address and we'll send you a link to reset your password.</p>

            {error && <div style={s.errorBox}>{error}</div>}

            <form onSubmit={submit}>
              <div style={s.inputWrap}>
                <label style={s.label}>Email Address</label>
                <input
                  type="email" placeholder="you@example.com"
                  value={email} onChange={e => setEmail(e.target.value)}
                  style={s.input} required
                />
              </div>
              <button type="submit" disabled={loading} style={s.btn}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <>
            <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#dcfce7', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M6 16l7 7 13-13" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 style={s.h2}>Check your email</h2>
            <p style={s.p}>We sent a password reset link to <strong>{email}</strong>. Click the link in the email to set a new password.</p>
            <p style={{ ...s.p, fontSize: 13, color: '#9099b4' }}>Didn't receive it? Check your spam folder, or</p>
            <button onClick={() => setSent(false)} style={{ ...s.btn, background: '#f8f9fc', color: '#1a1f5e', border: '1.5px solid #e2e6f0', marginTop: 4 }}>
              Try again
            </button>
            <Link to="/login" style={{ display: 'block', textAlign: 'center', marginTop: 16, fontSize: 14, color: '#4f6ef7', fontWeight: 600 }}>
              Back to login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

const s = {
  page:     { minHeight: '100vh', background: '#f8f9fc', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans',sans-serif", padding: 24 },
  card:     { background: '#fff', borderRadius: 20, padding: '40px 40px', maxWidth: 420, width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(15,18,51,.08)', border: '1px solid #e2e6f0' },
  back:     { display: 'inline-block', fontSize: 13, color: '#9099b4', textDecoration: 'none', marginBottom: 24 },
  logo:     { fontFamily: "'Sora',sans-serif", fontSize: 22, fontWeight: 700, color: '#1a1f5e', marginBottom: 24 },
  iconWrap: { width: 64, height: 64, borderRadius: '50%', background: '#eef1ff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' },
  h2:       { fontFamily: "'Sora',sans-serif", fontSize: 22, fontWeight: 700, color: '#1a1f5e', marginBottom: 10 },
  p:        { fontSize: 15, color: '#636b89', lineHeight: 1.65, marginBottom: 20 },
  errorBox: { background: '#fee2e2', color: '#dc2626', borderRadius: 10, padding: '11px 14px', fontSize: 14, marginBottom: 16, textAlign: 'left' },
  inputWrap:{ marginBottom: 16, textAlign: 'left' },
  label:    { display: 'block', fontSize: 13, fontWeight: 600, color: '#2e3456', marginBottom: 6 },
  input:    { width: '100%', padding: '11px 14px', border: '1.5px solid #e2e6f0', borderRadius: 10, fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  btn:      { width: '100%', padding: '13px', background: '#4f6ef7', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8 },
};
